// Shared by the Production pages.
export const KIND_LABEL = { goods: 'Bought to resell', material: 'Material', made: 'Made here' }
export const RUN_STATUS = { Open: { label: 'In progress', tone: 'info' }, Finished: { label: 'Finished', tone: 'good' }, Cancelled: { label: 'Cancelled', tone: 'muted' } }
